class Landing {
    constructor(el, options = {}){ 
        this.landing = el; 
        this.options = Object.assign(
            {},
            {  
                 
            }, 
            options
        );    
        document.querySelectorAll(".content-cta .addToCart").forEach(atc => {
            atc.addEventListener("click", (e) => {
                atc.classList.add("loading");
                let id = parseInt(atc.getAttribute("data-id"));
                theme.QuickAdd.prototype.addToCartFast(id);
            }); 
        });
    }
}

const landing = new Landing(document.querySelector(".landing"));